var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftBush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 141,
    viewBox: "0 0 336 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.178711 140.411C0.178711 140.411 3.07411 117.253 36.8462 121.112C36.8462 121.112 16.583 69.9696 52.2846 66.1082C87.9885 62.2492 111.147 87.3374 111.147 87.3374C111.147 87.3374 115.006 2.42069 163.255 0.491184C211.502 -1.43832 253.963 79.6194 253.963 79.6194C253.963 79.6194 261.683 46.8109 283.876 55.4948C306.071 64.1787 335.984 140.411 335.984 140.411H0.178711Z",
    fill: "#6B5E17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBush);
export default __webpack_public_path__ + "static/media/leftBush.cd03e6c08597f7b0a42ee18804bffb47.svg";
export { ForwardRef as ReactComponent };